import React from "react";
import { Target, Newspaper, Zap } from "lucide-react";
import Seo from "../components/Seo";
import "./About.css";

export default function About() {
  return (
    <div className="about-page" data-testid="about-page">
      <Seo
        title="About Race377"
        description="Race377 is independent motorsport journalism — covering Formula 1, WEC, IMSA, GT racing, Formula E, IndyCar, NASCAR and the business of racing with sharp analysis and unvarnished opinion."
      />

      <div className="page-hero">
        <div className="container">
          <span className="caption" style={{ color: "var(--brand-primary)" }}>Race377</span>
          <h1 className="brand-display" style={{ marginTop: 12 }}>About<br />Race377</h1>
          <p className="body-large" style={{ marginTop: 24, maxWidth: 640, fontWeight: 400, color: "var(--text-secondary)", fontSize: "1.15rem" }}>
            Independent motorsport journalism. Race reports you can trust, analysis you can&apos;t skim, and opinion that doesn&apos;t hedge.
          </p>
        </div>
      </div>

      <div className="container" style={{ paddingTop: 60, paddingBottom: 96 }}>
        <section className="mission-section">
          <h2 className="heading-2" style={{ marginBottom: 32 }}>What we cover</h2>
          <div className="mission-grid">
            <div className="mission-card">
              <div className="mission-icon"><Newspaper size={28} /></div>
              <h3 className="heading-3" style={{ fontSize: "1.25rem", marginTop: 16, marginBottom: 10 }}>The full calendar</h3>
              <p className="body-small">
                Formula 1, WEC, IMSA, GT World Challenge, Formula E, IndyCar and NASCAR — race weekends, mid-season storylines and championship arcs.
              </p>
            </div>
            <div className="mission-card">
              <div className="mission-icon"><Target size={28} /></div>
              <h3 className="heading-3" style={{ fontSize: "1.25rem", marginTop: 16, marginBottom: 10 }}>The business of racing</h3>
              <p className="body-small">
                Sponsorship, regulation, manufacturer commitments, broadcast deals. The stories that decide what happens on track six months out.
              </p>
            </div>
            <div className="mission-card">
              <div className="mission-icon"><Zap size={28} /></div>
              <h3 className="heading-3" style={{ fontSize: "1.25rem", marginTop: 16, marginBottom: 10 }}>Opinion that picks a side</h3>
              <p className="body-small">
                We don&apos;t do hot takes for clicks. We do considered arguments — and we&apos;ll tell you when we got it wrong.
              </p>
            </div>
          </div>
        </section>

        <section className="story-section" style={{ marginTop: 80 }}>
          <div className="story-content">
            <h2 className="heading-2" style={{ marginBottom: 24 }}>Editorial principles</h2>
            <p className="body-medium" style={{ marginBottom: 18 }}>
              No press release rewrites. No paywall on news. No paid placements disguised as editorial.
            </p>
            <p className="body-small" style={{ marginBottom: 18 }}>
              Race377 is reader-funded and editorially independent. We disclose any commercial relationships clearly. Corrections are made publicly and promptly. Our journalists are credited on every story.
            </p>
            <p className="body-small">
              If we cite a source, we link it. If we make a prediction, we revisit it. If a story changes after we publish, you&apos;ll see the update note at the top.
            </p>
          </div>
          <div className="story-image">
            <img src="https://images.unsplash.com/photo-1638820371262-862f2a0bde6b" alt="Motorsport newsroom" />
          </div>
        </section>
      </div>
    </div>
  );
}
